
import { BaseModulePublicApi } from "../../base/BaseModulePublicApi";

export class PublicTicketCollectionsApi extends BaseModulePublicApi {
  basePath = 'tickets_collections';
};
